import React, { useCallback } from 'react';

import { JobPostingModule } from '@/components/job-posting-module';
import { JDPModuleName } from '@/components/job-posting/types';
import { JobSalary } from '@/graphql/generated';
import { isValidSalary, isValidSalaryEstimate, isValidSalaryRange } from '@/helpers/salary-utils';
import { useBreakpoints } from '@/hooks';

import { ScrollTrackingModuleWrapper } from '../scroll-tracking-module-wrapper';
import { SalaryEstimation, SalaryExact, SalaryNotProvided, SalaryRange } from './components';

type Props = {
  moduleName: JDPModuleName;
  salary?: JobSalary | null;
};
import * as S from './salary-module.styles';

export const SalaryModule: React.VFC<Props> = ({ moduleName, salary }) => {
  const { isMobile } = useBreakpoints();

  const getSalaryContent = useCallback(() => {
    if (isValidSalary(salary)) {
      return <SalaryExact salary={salary} />;
    }
    if (isValidSalaryEstimate(salary)) {
      return <SalaryEstimation salary={salary} />;
    }
    if (isValidSalaryRange(salary)) {
      return <SalaryRange salary={salary} />;
    }

    return <SalaryNotProvided />;
  }, [salary]);

  return (
    <ScrollTrackingModuleWrapper moduleTrackingName={moduleName}>
      <JobPostingModule testId="posting-salary" data-cy="posting-salary">
        {!isMobile ? <S.StyledCard>{getSalaryContent()}</S.StyledCard> : getSalaryContent()}
      </JobPostingModule>
    </ScrollTrackingModuleWrapper>
  );
};
